import Description from "app/components/Description"
import InputField from "app/components/Form/Field/Input"
import { useSelector } from "react-redux"
import Heading from "app/components/Heading"
import { useTranslate } from "hooks/translate"
import Body from "app/components/Form/Body"
import { validateAmount, validateMax, validateMin } from "app/validation"
import { Locales } from "i18n"
import { getAppLocale } from "state/app/selectors"
import { parseLinks } from "i18n/utils/parseLinks"
import CheckboxField from "app/components/Form/Field/Checkbox"
import { useAppflow } from "app/hooks/useAppFlow"


const privacyLinks: {
  [key in Locales]: {
    [key: string]: string
  }
} = {
  [Locales.NL]: {
    link_kbc_privacy_policy:
      "https://www.kbc.be/particulieren/nl/juridische-info/privacyverklaring.html",
    link_kbc_privacy_annex:
      "https://multimediafiles.kbcgroup.eu/ng/published/KBC/PDF/kbc-privacyverklaring-annex.pdf"
  },
  [Locales.FR]: {
    link_kbc_privacy_policy:
      "https://www.kbc.be/particuliers/fr/informations-legales/vie-privee.html",
    link_kbc_privacy_annex:
      "https://multimediafiles.kbcgroup.eu/ng/published/KBC/PDF/kbc-declaration-vie-privee-annexe.pdf"
  }
}

const Step3: React.FC = () => {
  const { t } = useTranslate()
  const locale = useSelector(getAppLocale)
  const { clientType } = useAppflow()

  // KBC rejects anything below 1.000 euro with CO2019 "Het kredietbedrag is te klein".
  const MIN = 1000
  const MAX = 100000

  return (
    <>
      <Body>
        <Heading>{t(`form.step_4.${clientType}.heading`)}</Heading>
      </Body>
      <Heading as="h2" variant="strong">
        {t("system.amount")}
      </Heading>
      <Description>
        {t(`form.step_4.${clientType}.description.amount`)}
      </Description>
      <InputField
        name="desiredFinancingAmount"
        label="system.euro"
        labelPlacement="postfix"
        inputMode="numeric"
        description={t("form.field.desiredFinancingAmount.description", {
          min: MIN,
          max: MAX
        })}
        rules={{
          required: true,
          validate: {
            amount: validateAmount,
            min: validateMin(MIN),
            max: validateMax(MAX)
          }
        }}
      />
      <CheckboxField
        name="privacyPolicyKbc"
        rules={{ required: true }}
        label={t("system.kbc_privacy_disclaimer", {
          ...parseLinks({
            link_kbc_privacy_annex: {
              target: "_blank",
              href: privacyLinks[locale].link_kbc_privacy_annex
            },
            link_kbc_privacy_policy: {
              target: "_blank",
              href: privacyLinks[locale].link_kbc_privacy_policy
            }
          }),
          bank: "KBC",
          productName: t("system.product.loa.title")
        })}
      />
    </>
  )
}

export default Step3
